import { AlertCircle, AlertTriangle, CheckCircle2, Info } from 'lucide-react';

export function StatusNotice({ type = 'info', children }: { type?: 'info' | 'success' | 'warning' | 'error'; children: React.ReactNode }) {
  const Icon = type === 'success' ? CheckCircle2 : type === 'warning' ? AlertTriangle : type === 'error' ? AlertCircle : Info;
  return <div className={`status-notice ${type}`} role={type === 'error' ? 'alert' : 'status'}><Icon size={18} /><span>{children}</span></div>;
}
